var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOrganization28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 7.65685 9.65685 9 8 9C6.34315 9 5 7.65685 5 6C5 4.34315 6.34315 3 8 3C9.65685 3 11 4.34315 11 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.3333C3 12.4924 4.49238 11 6.33333 11H9.66667C10.0522 11 10.4224 11.0654 10.7669 11.1858C9.68597 12.103 9 13.4714 9 15C9 15.3425 9.03443 15.6769 9.10002 16H4.66667C3.74619 16 3 15.2538 3 14.3333Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15C19 15.3425 18.9656 15.6769 18.9 16H23.3333C24.2538 16 25 15.2538 25 14.3333C25 12.4924 23.5076 11 21.6667 11H18.3333C17.9478 11 17.5776 11.0654 17.2331 11.1858C18.314 12.103 19 13.4714 19 15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6C23 7.65685 21.6569 9 20 9C18.3431 9 17 7.65685 17 6C17 4.34315 18.3431 3 20 3C21.6569 3 23 4.34315 23 6Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15C17 16.6569 15.6569 18 14 18C12.3431 18 11 16.6569 11 15C11 13.3431 12.3431 12 14 12C15.6569 12 17 13.3431 17 15Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 23.3333C9 21.4924 10.4924 20 12.3333 20H15.6667C17.5076 20 19 21.4924 19 23.3333C19 24.2538 18.2538 25 17.3333 25H10.6667C9.74619 25 9 24.2538 9 23.3333Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrganization28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;